/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%}.passwordShowHide[_ngcontent-%COMP%]{position:absolute;right:0;border:0;border-left:1px solid #ccc;background:#fff}"];
export { styles as styles };
